/// <reference path="../../../components/controls/smartcenterdesigner/smartcenterdesignerproperties.component.ts" />

module Meevo.Plugins.SmartCenter {
    "use strict";

    export class SmartCenterContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        // Private members

        /**
         * The tile currently being edited
         */
        private currentEditorTile: SmartCenterSmartTileModel = null;

        /**
         * Indicates if a tile is currently being edited
         */
        private isEditingTile: boolean = false;
        public oldTileParams;
        protected oldTiles;

        private lastAddedTile: SmartCenterSmartTileModel = null;

        // END Private members

        // Public properties

        /**
         * The full collection of tile definitions
         */
        public tileDefinitions: Model.SmartTileDefinition[] = [];
        public currentLocation: number;
        /**
         * The filtered collection of tile definitions based on the currently applied filter
         */
        public filteredTileDefinitions: Model.SmartTileDefinition[] = [];

        /**
         * The currently selected tile category
         */
        public selectedTileCategory: Model.SmartTIleCategoryEnum = null;


        // END Public properties

        // Initialization

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            private commonDataService: Meevo.Components.Common.ICommonDataService,
            protected $mdSidenav: ng.material.ISidenavService,
            translate: angular.translate.ITranslateService,
            public currentSquares: number = 0,
            public maxSquares = 18) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, true, translate);
            this.baseEndpoint = appSettings.API_ENDPOINTS.smartCenter;
            this.sectionTemplatePath = "app/plugins/smartCenter/maintenance/sectionViews/";
            this.buildCrudSecurityKeys(this.securityKeys.DATA_SMARTCENTERDESIGNER_TAB_MAIN);
            this.entityType = 'SmartCenterDesigner';
            this.initializeSections();
            this.currentLocation = this.identityService.locationId;
            this.oldTileParams = undefined;

            // Hook to global exception interceptor for gridster errors
            (<any>window).gridsterPlacementError = () => {
                this.onGridsterPlacementError();
            };
        }

        protected initializeSections(): void {
            if (this.securityChecker.hasSecurity(this.securityKeys.DATA_SMARTCENTERDESIGNER_TAB_MAIN + this.securityParts.KEY_PART_READ)
                && this.sections.length == 0) {
                this.sections.push(new Meevo.Plugins.SmartCenter.MainSection(0, "Designer", "main.html", true, false, this.baseEndpoint, "",
                    this.loggingService, this.dataService, this.identityService, Model.NounEnum.SmartCenterDesignerMain, null, this.securityKeys.DATA_SMARTCENTERDESIGNER_TAB_MAIN + this.securityParts.KEY_PART_READ,
                    this.modalService, () => this.getTileDefinitions(), this.translateService));
            }
        }

        protected initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
            this.getTileDefinitions();
        }

        // END Initialization

        // Implementation

        public postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.SmartCenter>();
            model.displayName = undefined;
        }

        public getTilePosition(row, col) {
            return _.where((<Model.SmartCenter>this.selectedSection.model).tiles, { rowPosition: row, columnPosition: col });

        }

        public onDragStop = (tile: SmartCenterSmartTileModel) => {
            switch (tile.smartTileName) {
                case 'RetailUnitsSales': {
                    if (!tile.isInitialPositionChanged) {
                        break;
                    }

                    let params: any = {};
                    try {
                        params = JSON.parse(tile.parameter)
                    } catch (e) { }

                    if (params.multiSelectTemplateKey && params.multiSelectTemplateKey.selections && params.multiSelectTemplateKey.selections.length > 1) {
                        params.multiSelectTemplateKey.selections = [];
                        tile.parameter = JSON.stringify(params);
                        tile.parsedParameters = params;
                    }
                    tile.setInitialPositions();
                    break;
                }
            }

            // Root cause within the angular-gridster library can be investigated further. Overlap only seems to occur when
            // tile is moved from right to left (higher index column to lower). This is best way to handle externally for now.
            const groups = _.groupBy((<Model.SmartCenter>this.selectedSection.model).tiles, tile => {
                return `${tile.rowPosition}|${tile.columnPosition}`;
            });
            _.forEach(groups, group => {
                if (group.length > 1) {
                    if (group[0].rowPosition > 0) {
                        group[0].rowPosition = group[0].rowPosition - 1;
                    }
                }
            });
        }

        public updateCurrentSquares(tileParams, isOversized = false) {
            var tempSquares = 0;
            console.log(this.oldTileParams);
            (<Model.SmartCenter>this.selectedSection.model).tiles.forEach(function (tile, index) {
                tempSquares = tempSquares + tile.columnSpan * tile.rowSpan;
            });
            this.currentSquares = tempSquares;
        }

        public onResizeStart(tileParams) {
            this.oldTiles = JSON.parse(JSON.stringify((<Model.SmartCenter>this.selectedSection.model).tiles));
            this.oldTileParams = angular.copy(tileParams);
            console.log(this.oldTileParams);
        }

        public onResizeStop(tileParams) {
            var that = this;
            (<Model.SmartCenter>this.selectedSection.model).tiles.forEach(function (tile, index) {
                if (tile.parsedParameters[Meevo.Model.SmartTileParameterNames.image]) {
                    let matchedOldTile = _.filter(that.oldTiles, function (oldTile: any) {
                        let doTilesMatch = oldTile.$$hashKey == this.$$hashKey;
                        return doTilesMatch;
                    }, tile);
                    let oldTileAspectRatio = matchedOldTile[0].columnSpan / matchedOldTile[0].rowSpan;
                    let newTileAspectRatio = tile.columnSpan / tile.rowSpan;
                    let hasImage = !!matchedOldTile[0].parsedParameters[Meevo.Model.SmartTileParameterNames.image].parameterValue.fileGuid
                    if ((oldTileAspectRatio != newTileAspectRatio) && hasImage) {
                        that.modalService.confirmHandler("MESSAGE_IMAGE_RESIZE_WARNING")
                            .then(function (response) {
                                if (!response) {
                                    tile.rowSpan = matchedOldTile[0].rowSpan;
                                    tile.columnSpan = matchedOldTile[0].columnSpan;
                                }
                                else {
                                    let deleteJson = {
                                        FileGuid: tile.parsedParameters[Meevo.Model.SmartTileParameterNames.image].parameterValue.fileGuid,
                                        LocationId: that.locationId,
                                        ResourceType: tile.parsedParameters[Meevo.Model.SmartTileParameterNames.image].parameterValue.meevoFile.storageTypeEnum
                                    }
                                    //that.dataService.deleteFile("Storage/api", deleteJson);
                                    tile.parsedParameters[Meevo.Model.SmartTileParameterNames.image].parameterValue.fileGuid = "";
                                    tile.parsedParameters[Meevo.Model.SmartTileParameterNames.image].parameterValue.meevoFile = undefined;
                                }
                               
                                that.updateCurrentSquares(tileParams);
                            });
                    }
                    else {
                        that.updateCurrentSquares(tileParams);
                    }
                    that.oldTiles
                }

            });
            //update square count
        }

        public canAddMoreTiles() {
            if (this.currentSquares < this.maxSquares) {
                var thisSquare = 1 // default size of one square added
                this.currentSquares = this.currentSquares + thisSquare;
                console.log('current squares filled: ' + this.currentSquares);
                return true;
            } else {
                return;
            }
        }

        /**
         * Adds a concrete SmartCenterSmartTile instance to the current SmartCenter model
         * based on the incoming SmartTileDefinition
         * @param tileDefinition
         */
        public addTile(tileDefinition: Model.SmartTileDefinition): void {

            let newTile: SmartCenterSmartTileModel = new SmartCenterSmartTileModel({
                displayName: tileDefinition.displayName,
                displayNameOverride: '',
                backgroundColor: tileDefinition.backgroundColor ? _.clone(tileDefinition.backgroundColor) : '#95403F',
                columnSpan: 1,
                rowSpan: 1,
                parameter: tileDefinition.parameterDefaults,
                parsedParameters: tileDefinition.parameterDefaults ? JSON.parse(tileDefinition.parameterDefaults) : null,
                smartTileTypeEnum: tileDefinition.smartTileTypeEnum,
                id: tileDefinition.id,
                includedEmployee: 1969, // TODO: Placeholder - this will probably be replaced with the parameter model
                smartCenterTileId: null,
                smartTileName: tileDefinition.smartTileName,
                tileAvailabilityLevel: tileDefinition.tileAvailabilityLevel,
                desc: tileDefinition.desc
                //storedAspectRatio: 1
            });
            this.setDefaultDisplayNameForTile(newTile);
            this.setDefaultLocationForTile(newTile);

            if (this.canAddMoreTiles()) {
                newTile.hasExtendedData = tileDefinition.hasExtendedData;
                (<Model.SmartCenter>this.selectedSection.model).tiles.push(newTile);
                this.lastAddedTile = newTile;
            } else {
                this.modalService.alert('LABEL_ALERT_MAX_TILES');
            }
        }

        public hasTiles(): boolean {
          if (!this.selectedSection.model) {
            return false;  
          }
          const sc = <Model.SmartCenter>this.selectedSection.model;
          if (sc.tiles && sc.tiles.length > 0) {
            return true;
          } else {
            return false;
          }
        }

        private onGridsterPlacementError(): void {
            if (!this.lastAddedTile) {
                return;
            }
            const index = (<Model.SmartCenter>this.selectedSection.model).tiles.indexOf(this.lastAddedTile);
            if (index > -1) {
                (<Model.SmartCenter>this.selectedSection.model).tiles.splice(index, 1);
                this.modalService.alert('LABEL_SMARTCENTER_DESIGNER_PLACEMENT', Components.Modal.ModalTranslationModes.Translate)
            }
            this.lastAddedTile = null;
        }

        public setDefaultDisplayNameForTile(tile: SmartCenterSmartTileModel) {
            Meevo.Components.Controls.SmartCenterDesignerPropertiesHelper.buildDefaultDisplayName(this.translateService, tile);
        }

        private setDefaultLocationForTile(tile: SmartCenterSmartTileModel): void {
            if (!!tile.parsedParameters && !!tile.parsedParameters['locations']) {
                const smartCenter = this.castModel<Model.SmartCenter>();
                if (smartCenter && smartCenter.isAvailableCo) {
                    tile.parsedParameters['locations'].parameterDisplayName = this.identityService.current() ? this.identityService.current().locationName : null;
                }                
            }
        }

        /**
         * Removes a tile from the current SmartCenter model
         * @param tile
         */
        private removeTile(tile: SmartCenterSmartTileModel): void {
            var thisSquare = tile.rowSpan * tile.columnSpan;
            this.currentSquares = this.currentSquares - thisSquare;
            let smartCenter = this.castModel<Model.SmartCenter>();
            smartCenter.tiles = _.reject(smartCenter.tiles, (t) => {
                return t == tile;
            });
        }

        /**
         * Retrieves the full list of tile definitions which can be used to create concrete tile instances on the current Smart Center
         */
        public getTileDefinitions(): void {
            this.commonDataService.getSmartTileDefinitions(+this.selectedTileCategory).then((result: Model.SmartTileDefinition[]) => {
                let smartCenter = this.castModel<Model.SmartCenter>();
                var filteredResults = result;
                // Remove any smart tiles that should not appear in CO
               // Remove any smart tiles that should be available for CO
                if (this.isApplicationModeCO() && smartCenter.isAvailableCo) {
                    filteredResults = _.reject(filteredResults, s => s.tileAvailabilityLevel == Model.TileAvailabilityLevelEnum.LocationOnly);
                } else {
                    filteredResults = _.reject(filteredResults, s => s.tileAvailabilityLevel == Model.TileAvailabilityLevelEnum.CoOnly);
                }
                this.filteredTileDefinitions = this.tileDefinitions = _.sortBy(filteredResults, td => this.translateService.instant(td.displayName).trim());
                this.updateCurrentSquares(filteredResults);
            });
        }

        /**
         * Sets the specified tile to be the context of the tile editor
         * and updates the state to indicate that we are currently editing
         * @param tile
         */
        private editTile(tile: SmartCenterSmartTileModel): void {
            this.$mdSidenav('smartCenterDesignerEditor').open();
            let that = this;
            setTimeout(function () {
                angular.element('#smart-tile-designer-editor .md-sidenav-backdrop').on("click", function (event) {
                    that.completeTileEdit();
                });
            }, 100);

            this.currentEditorTile = tile;
            this.isEditingTile = true;
        }

        private cancelTileEdit() {
            this.$mdSidenav('smartCenterDesignerEditor').close();
            this.isEditingTile = false;
        }

        /**
         * Completes an edit on a tile, serializing the parameters and exiting tile edit state
         */
        private completeTileEdit(): void {

            // For some parameters (like image) we might want this to update in realtime versus on completion of the tile edit
            this.currentEditorTile.parameter = this.currentEditorTile.parsedParameters ? JSON.stringify(this.currentEditorTile.parsedParameters) : null;
            this.currentEditorTile = null;
            this.isEditingTile = false;
            this.$mdSidenav('smartCenterDesignerEditor').close();

        }

        //// TODO: This will be replaced with filtering by module   Model.SmartTIleCategoryEnum
        //private onSelectedTileCategoryChanged(): void {
        //  if (Model.Guard.isSomething(this.selectedTileCategory)) {
        //    this.filteredTileDefinitions = this.tileDefinitions.filter((tile: Model.SmartTileDefinition) => {
        //      return tile.tileCategory === this.selectedTileCategory;
        //    });
        //  } else {
        //    this.filteredTileDefinitions = this.tileDefinitions;
        //  }
        //}

        public cancel(): void {
            let that = this;

            this.modalService.confirmHandler("MESSAGE_SMART_CENTER_DESIGNER_WARNING")
                .then(response => {
                    if (response) {
                        that.currentSquares = 0;
                        if (that.isEditingTile) {
                            that.completeTileEdit();
                        }
                        super.cancel();
                    }
                });
        }

        public checkEdit(): boolean {
            return this.selectedSection.model.homeLocationId == this.currentLocation;
        }

        get showDelete(): boolean {
            return this.canDelete && this.checkEdit();
        }

        get showEdit(): boolean {
            return this.canEdit && this.checkEdit();
        }

        public get canEdit(): boolean {
            return this.isAccessible;
        }

        public save(): angular.IPromise<any> {

            let emptyImageFound = true;
            this.selectedSection.model.objectState = Meevo.Model.ObjectStateEnum.Active;
            var smartCenter = this.castModel<Model.SmartCenter>();

            smartCenter.availableToLocations = this.identityService.inCentralOfficeMode() ? this.selectedSection.model.availableToLocations : false;

            smartCenter.tiles.forEach(tile => {
                if (tile.smartTileTypeEnum === Meevo.Plugins.SmartCenter.TileTypes.Image) {
                    var imageParam = tile.parsedParameters[Meevo.Model.SmartTileParameterNames.image];
                    if (imageParam
                        && Model.Guard.isSomething(imageParam.parameterValue)
                        && Model.Guard.isNothing(imageParam.parameterValue.fileGuid)) {
                        emptyImageFound = false;
                    }
                }
            })
            if (!emptyImageFound) {
                this.busyService.stop();
                return this.modalService.alert('LABEL_PLEASE_UPLOAD_SMART_TILE_IMAGE', Components.Modal.ModalTranslationModes.Translate);
            }
            else {
                if (this.isEditingTile) {
                    this.completeTileEdit();
                }
                return super.save();
            }

        }

        public undelete(activate = false): void {
            super.undelete(true);
        }

        delete(): void {
            this.deleteConfirmationMessageKey = "MESSAGE_DELETE_SMARTCENTER";
            super.delete();          
        }



        // END Implementation
    }
}
